<header [preLogin]="false"></header>
<div class="pre-login">
    <div class="post-login-1-col-1 h-100">
        <app-left-panel-prelogin activeTab="3"></app-left-panel-prelogin>
    </div>
    <div class="post-login-1-col-2 p-mobile-15 h-100">
        <grid-row class="justify-content-center h-100vh-101">
            <grid-col col="4" mobile="12">
                <div *ngIf="emailusShow === 444"
                    class="color-base-700 font-400 font-size-20px line-h-25 mt-40 mt-mobile-0">
                    {{ "Fillform" | translate }}
                </div>
                <div *ngIf="!emailusShow" class="color-base-700 font-400 font-size-20px line-h-25 mt-40 mt-mobile-0">
                    {{ "TellUsFeedback" | translate }}
                </div>

                <div class="form-group mt-30">
                    <label>
                        {{ "NAME" | translate }}
                    </label>
                    <div>
                        <input type="text" placeholder="Please Enter" [(ngModel)]="name" (input)="validateName()"
                            [ngClass]="{'is-invalid': !isNameValid && name !== ''}" />
                        <div *ngIf="!isNameValid && name !== ''" class="error-text">
                            {{ "Name cannot contain numbers" | translate }}
                        </div>
                    </div>
                </div>
                <div class="form-group mt-25">
                    <label>
                        {{ "Email" | translate }}
                    </label>
                    <div>
                        <input type="text" placeholder="Please Enter" [(ngModel)]="email" (input)="validateEmail()"
                            [ngClass]="{'is-invalid': !isEmailValid && email !== ''}" />
                        <div *ngIf="!isEmailValid && email !== ''" class="error-text">
                            {{ "Invalid email format" | translate }}
                        </div>
                    </div>
                </div>
                <div class="form-group mt-25 mt-mobile-15">
                    <grid-row class="col-space-min">
                        <grid-col col="12">
                            <label class="no-mark">
                                {{ "MobileNumber" | translate }}
                            </label>
                        </grid-col>
                        <grid-col col="3">
                            <select type="text" placeholder="+973">
                                <option value="">+973</option>

                            </select>
                        </grid-col>
                        <grid-col col="9">
                            <div>
                                <input type="tel" placeholder="Please Enter" [(ngModel)]="number"
                                    (input)="validateMobileNumber()"
                                    [ngClass]="{'is-invalid': !isMobileNumberValid && number !== ''}" />
                                <div *ngIf="!isMobileNumberValid && number !== ''" class="error-text">
                                    {{ "Mobile number must be up to 8 digits" | translate }}
                                </div>
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
                <div class="form-group mt-25 mt-mobile-15">
                    <label>
                        {{ "IdNumber" | translate }}
                    </label>
                    <div>
                        <input type="number" placeholder="Please Enter" [(ngModel)]="IdNumber"
                            (input)="validateIdNumber()"
                            [ngClass]="{'is-invalid': !isIdNumberValid && IdNumber !== ''}" />
                        <div *ngIf="!isIdNumberValid && IdNumber !== ''" class="error-text">
                            {{ "ID number must contain only numbers" | translate }}
                        </div>
                    </div>
                </div>
                <div class="form-group mt-25 mt-mobile-15">
                    <label>{{"Nationality" | translate}}</label>
                    <drop-down-list dropDownImage="false" dropDownSearch="false"
                        [selectedValue]="this.selectedNationality" [dropDownData]="this.Nationalitylist"
                        (itemselected)="onNationalityChange($event)">
                        {{this.selectedNationality}}
                    </drop-down-list>
                </div>
                <div class="form-group mt-25 mt-mobile-15">
                    <label>
                        {{ "COMPANY" | translate }}
                    </label>
                    <div>
                        <input type="text" placeholder="Please Enter" [(ngModel)]="Company">
                    </div>
                </div>
                <div class="form-group mt-25 mt-mobile-15">
                    <label class="no-mark">
                        {{ "MESSAGE" | translate }}
                    </label>
                    <textarea rows="2" type="text" placeholder="Please Enter" [(ngModel)]="Msg">
                    </textarea>
                    <!-- placeholder="{{'IEncounteredIssue'| translate }}" -->
                    <!-- <div class="font-600 font-size-14px color-base-700 line-h-22 letter-spacing-03 mb-12 mt-12">
                            {{ "IEncounteredIssue" | translate }} 
                        </div> -->
                </div>
                <grid-row class="mt-50 mb-20 mt-mobile-15">
                    <grid-col col="12">
                        <button class="btn-dft" [disabled]="Valid()" (click)="feedbackSuccess()">
                            {{ "Next" | translate }}
                        </button>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
    </div>
</div>